<template>
  <alert-card
    display="scroll-window"
    :primaryHeading="`Invoices Overdue (${delinquentEvents.length})`"
  >
    <contact-event-details
      v-for="(event, index) in delinquentEvents"
      :key="index"
      :event="event"
      :requests="['formatted-date', 'total']"
      class="overdue-invoice-list-item"
      @click="navigateToEvent(event)"
    />
  </alert-card>
</template>
<script>
import AlertCard from "../../../Components/UI/AlertCard.vue";
import ContactEventDetails from "../../../Components/UI/ListItems/Event/ContactEventDetails.vue";
import { delinquentEvents } from "../../../Helpers/events.js";
export default {
  data() {
    return {};
  },
  computed: {
    delinquentEvents() {
      return delinquentEvents();
    },
  },
  methods: {
    navigateToEvent(event) {
      this.$router.push(`/event/${event.tenantId}/${event.userId}`);
    },
  },
  components: { AlertCard, ContactEventDetails },
};
</script>
<style scoped>
.overdue-invoice-list-item {
  height: 40px;
  margin: 5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
